export default class editClassEnum {
    static FALLBACK_ID = -1;
}



// WEBPACK FOOTER //
// ./app/containers/edit-class/constants.js